import { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleUserInfo } from "../../redux/actions/userInfo";
import * as PATH from "../../utils/Contants"; //"../../global/Contants";
import { genApiConfig } from "../../utils/fetch-caller";
import { getArgsQuery } from "../../utils/GlobalFunction";
import { getConfig } from "../../config/runtimeConfig";
import { finishCasLogoutCallback } from "../../utils/auth/logout";
import {
  CheckSSoUserUsingPOSTRequest,
  MemberControllerApi,
  RoleDto,
  SsoUserDto,
  SsoUserResponse,
} from "../../fetcher";

const CasRedirectView = (props: any) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("hashRouter", getArgsQuery());
    let query = getArgsQuery();
    if (query.action !== null && query.action === "logout") {
      finishCasLogoutCallback(props.handleUserInfo);
      return;
    } else {
      if (query !== null) {
        const config = getConfig();
        const serverUrl = config.SAML_SERVER_URL;
        fetch(`${serverUrl}/cas/register`, {
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            ssoId: query.ssoId,
            roleName: config.WEB_NAME,
          }),
        })
          .then((res) => {
            res.json().then(async (res) => {
              debugger;
              console.log("cas", res);

              if (res.hasOwnProperty("error")) {
                alert(res.error_description);
                return;
              }
              let newObj = {};

              new MemberControllerApi(genApiConfig())
                .checkSSoUserUsingPOST({
                  username: res.name,
                  ssoUserDto: {
                    age: res.age,
                    className: res.className,
                    classNumber: res.classNumber,
                    email: res.email,
                    gender: res.gender,
                    grade: res.grade,
                    hashPassword: res.hashPassword,
                    role: {
                      name: res.role[0].name,
                      roleId: res.role[0].id,
                      isAdmin: res.role[0].isAdmin,
                    } as RoleDto,
                    userId: res.userId,
                    chtName: res.chtName,
                    engName: res.engName,
                  } as SsoUserDto,
                } as CheckSSoUserUsingPOSTRequest)
                .then((resLibrary: SsoUserResponse) => {
                  if (resLibrary.adminMember !== undefined) {
                    newObj = Object.assign({
                      ...res,
                      isAdmin: res.role[0].isAdmin,
                      member: resLibrary.adminMember,
                    });
                  }
                  if (resLibrary.member !== undefined) {
                    console.log("resLib", resLibrary.member);
                    newObj = Object.assign({
                      ...res,
                      isAdmin: res.role[0].isAdmin,
                      member: resLibrary.member,
                    });
                  }

                  localStorage.setItem(PATH.USER_INFO, JSON.stringify(newObj));
                  localStorage.setItem(PATH.ACCESS_TOKEN, resLibrary.token!!);
                  localStorage.setItem(
                    PATH.REFRESH_TOKEN,
                    resLibrary.refreshToken!!,
                  );
                  props.handleUserInfo(newObj);
                  
                  const redirectUrl = localStorage.getItem('redirectUrl');
                  if (redirectUrl) {
                    window.location.href = redirectUrl;
                    localStorage.removeItem('redirectUrl'); // 清除保存的 URL
                  } else {
                    navigate(PATH.HOME_PATH);
                  }
                  //navigate(PATH.HOME_PATH);
                });
            });
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    }
  }, []);

  return <div>Redirect...</div>;
};

const mapStateToProps = (state: any) => {
  return {
    userInfo: state.userInfo.userInfo,
  };
};

const actionCreator = {
  handleUserInfo,
};

export default connect(mapStateToProps, actionCreator)(CasRedirectView);

